module.exports = __webpack_public_path__ + "img/home_roundtable.ac3a1d87.png";